module.exports = "/virtual-football/img/video/clubs/italy/inter.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/italy/inter.png
// module id = 299
// module chunks = 6